import { Component, OnInit, Input, HostBinding } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-msg-erro',
  templateUrl: './msg-erro.component.html',
  styleUrls: ['./msg-erro.component.scss']
})
export class MsgErroComponent implements OnInit {

  @Input() control: FormControl;

  @Input() @HostBinding('class.fixed-msg-erro-display') sempreExibir:boolean = false;

  constructor() { }

  ngOnInit() {
  }

}
